import React from 'react';
import { RegisterForm } from '../../register/presentation/RegisterForm';
import { useModuleFeatures } from '@/hooks/useModuleFeatures';

export const RegisterPage: React.FC = () => {
  const { features } = useModuleFeatures();

  return (
    <div className={`h-full flex items-center justify-center rounded-lg ${features.neumorphism ? 'bg-gray-100 dark:bg-gray-900' : 'bg-white dark:bg-gray-800'}`}>
      <div className={`w-full px-8 py-4 bg-white dark:bg-gray-800 border-2 rounded-lg shadow-xl`}>
        <RegisterForm />
      </div>
    </div>
  );
}; 